import ImageBasic from '~/components/Image/ImageBasic';
import ImageLoader from '~/components/Image/ImageLoader';

export { ImageLoader };
const Image = ImageBasic;
export default Image;
